import * as a from 'actions/products';

const initial = {
  data: [],
  error: null,
};

const products = (state = initial, action = null) => {
  switch (action.type) {
    case a.SET_PRODUCTS:
      return {
        ...state,
        data: action.products,
        error: null,
      };
    case a.SET_PRODUCTS_ERROR:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default products;
